/**
 * Holds its scene's probes while a ReflectionProbe component is mounted, and drives them once a
 * frame. The first holder drives, so a scene with several probes updates them once.
 */
import { useRef } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import { useResourceLoader } from '../../resources/useResource.js';
import { textureWork } from '../../resources/textures/textureWork.js';
import { fontWork } from '../controls/native/text/settledChannel.js';
import { SceneHolding } from '../sceneHolding.js';
import { useSceneHolder } from '../useSceneHolder.js';
import { useProjectClearColor } from '../useProjectClearColor.js';
import { SceneProbes } from './sceneProbes.js';
const probesOfScenes = new SceneHolding((scene, renderer) => new SceneProbes(renderer, scene));
export function useSceneProbes() {
    const scene = useThree((state) => state.scene);
    const invalidate = useThree((state) => state.invalidate);
    const loader = useResourceLoader();
    const clearColor = useRef(null);
    clearColor.current = useProjectClearColor();
    const holder = useSceneHolder(probesOfScenes);
    useFrame(() => {
        const probes = probesOfScenes.drivenBy(scene, holder);
        if (!probes)
            return;
        const pending = (loader?.pendingResourceCount ?? 0) + textureWork.pending() + fontWork.pending();
        if (probes.update(pending, clearColor.current))
            invalidate();
    });
}
//# sourceMappingURL=useSceneProbes.js.map